// src/components/Privacy.jsx
import { getUserLanguage } from '../utils/language';
import Navbar from '../components/common/NavBar';
import MiniHero from '../components/common/MiniHero';
import Footer from '../components/common/Footer';

const Privacy = () => {
  const language = getUserLanguage();

  const texts = {
    cs: {
      title: 'Zásady ochrany osobních údajů',
      intro:
        'Ochrana vašeho soukromí je pro nás prioritou. Tato zásada ochrany osobních údajů popisuje, jak NO RISK NO DRIFT shromažďuje, používá a chrání vaše osobní údaje na našem webu a e-shopu.',
      sections: {
        intro: {
          title: '1. Úvod',
          content:
            'NO RISK NO DRIFT (dále jen "my" nebo "Správce") provozuje webové stránky a e-shop na adrese [URL webu]. Tyto zásady vysvětlují, jak nakládáme s vašimi osobními údaji v souladu s Nařízením EU 2016/679 (GDPR) a českými zákony.',
        },
        collection: {
          title: '2. Shromažďování osobních údajů',
          content:
            'Shromažďujeme údaje, které nám dobrovolně poskytnete, například jméno, e-mail, telefonní číslo a adresu při vyplnění kontaktního formuláře, registraci nebo nákupu v e-shopu. Dále automaticky sbíráme technické údaje (IP adresa, typ zařízení, cookies) pro zlepšení funkčnosti webu.',
        },
        usage: {
          title: '3. Použití osobních údajů',
          content:
            'Vaše údaje používáme k: (a) zpracování objednávek v e-shopu, (b) komunikaci s vámi (např. odpovědi na dotazy), (c) zasílání novinek (pouze se souhlasem), (d) analýze a zlepšování našich služeb. Právním základem je plnění smlouvy, váš souhlas nebo oprávněný zájem.',
        },
        sharing: {
          title: '4. Sdílení údajů',
          content:
            'Vaše údaje nesdílíme s třetími stranami, kromě: (a) poskytovatelů služeb (např. dopravci pro doručení zboží, platební brány), (b) případů, kdy to vyžaduje zákon. Všichni zpracovatelé jsou vázáni smlouvami o ochraně údajů.',
        },
        rights: {
          title: '5. Vaše práva',
          content:
            'Máte právo: (a) požádat o přístup k vašim údajům, (b) požadovat jejich opravu nebo výmaz, (c) omezit zpracování, (d) vznést námitku proti zpracování, (e) na přenositelnost údajů, (f) odvolat souhlas (pokud byl dán). Kontaktujte nás na [email z ContactSection].',
        },
        cookies: {
          title: '6. Cookies',
          content:
            'Používáme cookies k zajištění funkčnosti webu, analýze návštěvnosti a personalizaci obsahu. Nezbytné cookies nevyžadují souhlas, ostatní můžete odmítnout v nastavení cookies na webu.',
        },
        security: {
          title: '7. Zabezpečení údajů',
          content:
            'Vaše údaje chráníme pomocí technických a organizačních opatření (šifrování, omezený přístup). Přesto žádný systém není 100% bezpečný, a proto riziko narušení nelze zcela vyloučit.',
        },
        retention: {
          title: '8. Doba uchování údajů',
          content:
            'Údaje uchováváme pouze po nezbytnou dobu: (a) objednávky po dobu 5 let (zákonné povinnosti), (b) kontaktní údaje do odvolání souhlasu nebo ukončení komunikace, (c) technické údaje max. 1 rok.',
        },
        contact: {
          title: '9. Kontakt a stížnosti',
          content:
            'Správcem údajů je NO RISK NO DRIFT. Pro dotazy nás kontaktujte na [email z ContactSection]. Máte-li stížnost, můžete se obrátit na Úřad pro ochranu osobních údajů (www.uoou.cz).',
        },
      },
    },
    en: {
      title: 'Privacy Policy',
      intro:
        'Protecting your privacy is our priority. This Privacy Policy describes how NO RISK NO DRIFT collects, uses, and protects your personal data on our website and e-shop.',
      sections: {
        intro: {
          title: '1. Introduction',
          content:
            'NO RISK NO DRIFT (hereinafter "we" or "Controller") operates the website and e-shop at [website URL]. This policy explains how we handle your personal data in compliance with EU Regulation 2016/679 (GDPR) and Czech laws.',
        },
        collection: {
          title: '2. Collection of Personal Data',
          content:
            'We collect data you voluntarily provide, such as name, email, phone number, and address when filling out a contact form, registering, or purchasing in the e-shop. We also automatically collect technical data (IP address, device type, cookies) to improve website functionality.',
        },
        usage: {
          title: '3. Use of Personal Data',
          content:
            'We use your data to: (a) process e-shop orders, (b) communicate with you (e.g., respond to inquiries), (c) send newsletters (with consent only), (d) analyze and improve our services. The legal basis is contract fulfillment, your consent, or legitimate interest.',
        },
        sharing: {
          title: '4. Data Sharing',
          content:
            'We do not share your data with third parties, except: (a) service providers (e.g., shipping companies, payment gateways), (b) when required by law. All processors are bound by data protection agreements.',
        },
        rights: {
          title: '5. Your Rights',
          content:
            'You have the right to: (a) access your data, (b) request correction or deletion, (c) restrict processing, (d) object to processing, (e) data portability, (f) withdraw consent (if given). Contact us at [email from ContactSection].',
        },
        cookies: {
          title: '6. Cookies',
          content:
            'We use cookies to ensure website functionality, analyze traffic, and personalize content. Essential cookies do not require consent; others can be declined in the cookie settings on the website.',
        },
        security: {
          title: '7. Data Security',
          content:
            'We protect your data with technical and organizational measures (encryption, restricted access). However, no system is 100% secure, and the risk of a breach cannot be entirely eliminated.',
        },
        retention: {
          title: '8. Data Retention Period',
          content:
            'We retain data only as long as necessary: (a) order data for 5 years (legal obligations), (b) contact data until consent is withdrawn or communication ends, (c) technical data for up to 1 year.',
        },
        contact: {
          title: '9. Contact and Complaints',
          content:
            'The data controller is NO RISK NO DRIFT. For questions, contact us at [email from ContactSection]. If you have a complaint, you may contact the Czech Data Protection Authority (www.uoou.cz).',
        },
      },
    },
  };

  // Placeholder nastavení patičky (nahraďte dynamickým načítáním, pokud je potřeba)
  const footerSettings = {
    instagram: 'https://instagram.com/norisknodrift',
    facebook: 'https://facebook.com/norisknodrift',
    youtube: 'https://youtube.com/norisknodrift',
    tiktok: 'https://tiktok.com/@norisknodrift',
  };

  const currentText = texts[language] || texts.en; // Fallback na angličtinu

  return (
    <div className="min-h-screen bg-black">
      {/* Navigační lišta */}
      <Navbar language={language} />

      {/* MiniHero sekce */}
      <MiniHero title={currentText.title} description={currentText.intro} />

      {/* Hlavní obsah */}
      <div className="container mx-auto px-4 py-10 text-white">
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.intro.title}</h2>
          <p className="text-gray-400">{currentText.sections.intro.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.collection.title}</h2>
          <p className="text-gray-400">{currentText.sections.collection.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.usage.title}</h2>
          <p className="text-gray-400">{currentText.sections.usage.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.sharing.title}</h2>
          <p className="text-gray-400">{currentText.sections.sharing.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.rights.title}</h2>
          <p className="text-gray-400">{currentText.sections.rights.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.cookies.title}</h2>
          <p className="text-gray-400">{currentText.sections.cookies.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.security.title}</h2>
          <p className="text-gray-400">{currentText.sections.security.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.retention.title}</h2>
          <p className="text-gray-400">{currentText.sections.retention.content}</p>
        </section>
        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{currentText.sections.contact.title}</h2>
          <p className="text-gray-400">{currentText.sections.contact.content}</p>
        </section>
      </div>

      {/* Patička */}
      <Footer
        instagram={footerSettings.instagram}
        facebook={footerSettings.facebook}
        youtube={footerSettings.youtube}
        tiktok={footerSettings.tiktok}
      />
    </div>
  );
};

export default Privacy;
